import { NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { BoardResolutionApprovingPersonsModel } from '@portal/application/data-access';

@Component({
  selector: 'portal-application-array-board-resolution',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, MatIconModule, NgIf, NgForOf],
  template: `
    <div class="mb-3">
      <legend *ngIf="props.label">{{ props.label }}</legend>
      <p *ngIf="props.description">{{ props.description }}</p>

      <div *ngFor="let f of field.fieldGroup; let i = index">
        <div class="flex justify-between">
          <p class="text-turquoise font-bold portal-paragraph">Signatory #{{ i + 1 }}</p>
          <!--          <button-->
          <!--            *ngIf="!disabled && deletable(i)"-->
          <!--            type="button"-->
          <!--            (click)="remove(i)"-->
          <!--          >-->
          <!--            <mat-icon-->
          <!--              class="icon-size-5 text-primary"-->
          <!--              svgIcon="recycle_bin"-->
          <!--            >-->
          <!--            </mat-icon>-->
          <!--          </button>-->
        </div>
        <formly-field
          class="col"
          [field]="f"
        ></formly-field>
      </div>

      <!--            <div class="flex">-->
      <!--              <button-->
      <!--                *ngIf="!disabled && available"-->
      <!--                class="btn btn-primary flex gap-2 ms-auto"-->
      <!--                type="button"-->
      <!--                (click)="add()"-->
      <!--              >-->
      <!--                <span class="font-bold">Add Another Signatory</span>-->
      <!--                <span class="flex items-center justify-center">-->
      <!--                  <mat-icon class="field-file-prefix text-green">add_circle_outline</mat-icon>-->
      <!--                </span>-->
      <!--              </button>-->
      <!--            </div>-->

      <formly-validation-message
        *ngIf="showError"
        class="block text-xs text-primary mt-1"
        [field]="field"
      ></formly-validation-message>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormArrayBoardResolutionComponent extends FieldArrayType<PortalFieldTypeConfig> implements OnInit {
  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }

  // get available(): boolean {
  //   return this.props.maxLength
  //     ? !this.formState?.hideApprovingPersons && Array.isArray(this.field.fieldGroup) && this.field.fieldGroup.length < this.props.maxLength
  //     : false;
  // }

  deletable(index: number): boolean {
    const nonDeletable = this.options?.formState?.nonDeletable;
    return !(Array.isArray(nonDeletable) && nonDeletable.includes(index));
  }

  override add(): void {
    super.add(undefined, BoardResolutionApprovingPersonsModel.createEmpty());
  }

  ngOnInit(): void {
    this.field.props.add = this.add.bind(this);
    this.field.props.remove = this.remove.bind(this);
  }
}

@NgModule({
  imports: [
    FormlyModule.forChild({
      types: [{ name: 'form-array-board-resolution', component: FormArrayBoardResolutionComponent }],
    }),
  ],
})
export class FormArrayBoardResolutionModule {}
